import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../../shared/services/payment.service';
import { PaymentStartStage } from '../../../model/enum/payment.start.stage';
import { MessageService } from '../../../shared/services/message-service';
import {NetmeraService} from "../../../shared/services/netmera-service";
import {OdemeSonuc} from "../../../model/netmera-events/odeme-sonuc";
import {SessionService} from "../../../shared/services/session.service";
import {UserDto} from "../../../model/user/user-dto";
import {Error} from "../../../model/netmera-events/error";
import {Purchase} from "../../../model/netmera-events/purchase";

@Component({
  selector: 'pa-payment-threed-result',
  templateUrl: './payment-threed-result.component.html',
  styleUrls: ['./payment-threed-result.component.scss']
})
export class PaymentThreedResultComponent implements OnInit {

  loading: boolean = false;
  trackingId: string;
  paymentMethodType: string;
  user: UserDto;

  constructor(private router: Router, private route: ActivatedRoute, private paymentService: PaymentService,
              private messageService: MessageService, private sessionService: SessionService, private netmeraService: NetmeraService,
              private odemeSonuc: OdemeSonuc, private purchase: Purchase, private error: Error) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      let sessionId: string = params.sessionId;
      this.trackingId = params.trackingId;
      this.getUser();
      if (!sessionId) {
        this.pushPaymentResultEvent("PageNotFound");
        this.router.navigate(['/result/page-not-found']);
        return;
      }
      this.loading = true;
      this.paymentService.getThreeDResult(sessionId, this.trackingId).subscribe(
        response => {
          this.loading = false;
          if (PaymentStartStage.NO_PAYMENT === response.stage) {
            this.pushPaymentResultEvent("OdemeBasarisiz");
            this.netmeraService.pushEvent(this.error.setEventObject("OdemeBasarisiz", this.user?.requestHeader?.merchant?.merchantCode));
            this.router.navigate(['/payment/selection', this.trackingId]);
            this.messageService.setMessage(response.threeDError);
            return;
          }

          if (PaymentStartStage.PAYMENT_RESULT === response.stage) {
            this.pushPaymentResultEvent("OdemeBasarili");
            this.pushPurchaseEvent();
            this.router.navigate(['/result/payment', this.trackingId], {queryParams: response.params});
            return;
          }
          this.pushPaymentResultEvent("PageNotFound");
          this.router.navigate(['/result/page-not-found']);
          return;
        }, error => {
          this.pushPaymentResultEvent("OdemeBasarisiz");
          this.netmeraService.pushEvent(this.error.setEventObject("OdemeBasarisiz", this.user?.requestHeader?.merchant?.merchantCode));
          this.loading = false;
          this.router.navigate(['/result/error', this.trackingId]);
        }
      );
    });
  }

  getUser() {
    this.sessionService.getInitUser(this.trackingId).subscribe(response => {
      if (response != null) {
        this.user = response;
        this.netmeraService.setUser(this.user?.account?.externalId);
      }
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  pushPurchaseEvent() {
    this.netmeraService.pushEvent(this.purchase.setEventObject(null, null, null,
      null, null, null, Number(this.user?.payment?.amount)/100));
  }

  pushPaymentResultEvent(detay: string) {
    this.netmeraService.pushEvent(this.odemeSonuc.setEventObject(detay, this.user?.requestHeader?.merchant?.merchantCode, this.getPaymentMethodType(), true,
      null, +this.user?.payment?.installment?.count, Number(this.user?.payment?.amount)/100));
  }

  getPaymentMethodType(): string {
    this.paymentMethodType = this.user?.payment?.paymentMethodDTO?.paymentMethodType;
    if (this.paymentMethodType === 'CREDIT_CARD' && this.user?.payment?.paymentMethodDTO?.cardBrand === 'PCARD') {
      this.paymentMethodType = 'PCARD';
    }
    return this.paymentMethodType;
  }

}
